export default {

    // //esse nao ta sendo utilizado pois repete uma outra funcao mais abaixo
    // max(array, propriedade) {
    //     if (!!propriedade)
    //         return array.reduce(function(prev, current) {
    //             return (prev[propriedade] > current[propriedade]) ? prev : current
    //         })
    //     else            
    //         return array.reduce(function(prev, current) {
    //             return (prev > current) ? prev : current
    //         })
    // },

    sum(array, propriedade) {
        if (!!propriedade){
            let allNull = true;
            let resultado = array.reduce(function(a, b) {
                if (b[propriedade] == null) {
                    return a; 
                }
                allNull = false; // Se encontrar um valor não null, seta a flag para false
                return a + b[propriedade];
            }, 0);

            return allNull ? null : resultado;
        }
        else{
            let allNull = true;
            let resultado = array.reduce(function(a, b) {
                if (b == null) {
                    return a; 
                }
                allNull = false; // Se encontrar um valor não null, seta a flag para false
                return a + b;
            }, 0);

            return allNull ? null : resultado;
        }
    },
    
    formatTime(value) {
        let negativo = value < 0;
        value = Math.abs(Math.trunc(value))
        let horas = String(Math.trunc(value / 3600)).padStart(2, "0")
        let minutos = String(Math.trunc(((value % 3600) / 60))).padStart(2, "0");
        let segundos = String(value - ((horas * 3600) + (minutos * 60))).padStart(2, "0");
        return `${negativo ? "-" : ""}${horas}:${minutos}:${segundos}`
    },
    
    sumTime(array, propriedade) {
        let horasSec = []
        if (!!propriedade)
            horasSec = array.map(reg => {
                const [ horas = 0, minutos = 0, segundos = 0 ] = reg[propriedade].split(':')
                return parseInt(horas * 3600) + parseInt(minutos * 60) + parseInt(segundos)
            })
        else
            horasSec = array.map(reg => {
                const [ horas = 0, minutos = 0, segundos = 0 ] = reg.split(':')
                return parseInt(horas * 3600) + parseInt(minutos * 60) + parseInt(segundos)
            })
        let somaSec = horasSec.reduce((agg, atual) => agg + atual, 0)
        return this.formatTime(somaSec)
    },

    avg(array, propriedade) {
        if (!!propriedade){
            let allNull = true
            let result = array.reduce(function(a, b) {
                if(b[propriedade] == null){
                    return a
                }
                allNull = false;
                return  a + b[propriedade];
            }, 0) 
            return allNull ? null : result / array.length;
        }
        else{
            let allNull = true
            let result = array.reduce(function(a, b) {
                if(b[propriedade] == null){
                    return a
                }
                allNull = false;
                return a + b;
            }, 0)
            return allNull ? null : result / array.length;   
        }     
    },

    formatTime(value) {
        let negativo = value < 0;
        value = Math.abs(Math.trunc(value))
        let horas = String(Math.trunc(value / 3600)).padStart(2, "0")
        let minutos = String(Math.trunc(((value % 3600) / 60))).padStart(2, "0");
        let segundos = String(value - ((horas * 3600) + (minutos * 60))).padStart(2, "0");
        return `${negativo ? "-" : ""}${horas}:${minutos}:${segundos}`
    },
    sumTime(array, propriedade, format = true) {
        let horasSec = [];
        horasSec = array.map(reg => {
            const [horas = 0, minutos = 0, segundos = 0] = (propriedade ? reg[propriedade] : reg).split(':').map(Number);
            return horas * 3600 + minutos * 60 + segundos;
        });
    
        let somaSec = horasSec.reduce((agg, atual) => agg + atual, 0);
        return format ? this.formatTime(somaSec) : somaSec;
    },
    // sumTime(array, propriedade, format = true) {
    //     let horasSec = []
    //     if (!!propriedade)
    //         horasSec = array.map(reg => {
    //             const [ horas = 0, minutos = 0, segundos = 0 ] = reg[propriedade].split(':')
    //             return parseInt(horas * 3600) + parseInt(minutos * 60) + parseInt(segundos)
    //         })
    //     else
    //         horasSec = array.map(reg => {
    //             const [ horas = 0, minutos = 0, segundos = 0 ] = reg.split(':')
    //             return parseInt(horas * 3600) + parseInt(minutos * 60) + parseInt(segundos)
    //         })
    //     let somaSec = horasSec.reduce((agg, atual) => agg + atual, 0)
    //     return format ? this.formatTime(somaSec) : somaSec
    // },
    
    avgTime(array, propriedade) {
        let sum = this.sumTime(array, propriedade, false)
        return this.formatTime(sum / array.length)
    },

    min(array, propriedade) {
        if (!!propriedade)
            return array.reduce(function(a, b) {
                return a == null ? b[propriedade] : (b[propriedade] == null ? a : (a > b[propriedade] ? b[propriedade] : a));
            }, null);
        else
            return array.reduce(function(a, b) {
                return a == null ? b : (b == null ? a : (a > b ? b : a));
            }, null);
    },

    max(array, propriedade) {
        if (!!propriedade)
            return array.reduce(function(a, b) {
                return a == null ? b[propriedade] : (b[propriedade] == null ? a : (a < b[propriedade] ? b[propriedade] : a));
            }, null);
        else
            return array.reduce(function(a, b) {
                return a == null ? b : (b == null ? a : (a < b ? b : a));
            }, null);
    },

    count(array, propriedade) {
        let array2 = this.distinct(array, propriedade)
        //conta todos os registros que não são vazios
        return array2.reduce(function(a, b) {
                return a == null ? 1 : (b == null ? a : (a + 1));
            }, 0);
    },

    distinct(array, propriedade) {
        if (!!propriedade)
            return [... new Set(array.map(d => d[propriedade]))]
        else
            return [... new Set(array)]
    },

    first(array, propriedade) {
        if (!array.length)
            return
        if (!!propriedade)
            return array[0][propriedade]
        else
            return array[0]
    },

    last(array, propriedade) {
        if (!array.length)
            return
        if (!!propriedade)
            return array[array.length - 1][propriedade]
        else
            return array[array.length - 1]
    },

    /*
        const array = [
        { class: "second", fare: "a" }, 
        { class: "second", fare: "b" }, 
        { class: "first", fare: "a" }, 
        { class: "first", fare: "a" }, 
        { class: "second", fare: "a" }, 
        { class: "first", fare: "c" }
        ];

        unique(array, ['class', 'fare']);

        //resposta:
        [
            { "class": "second", "fare": "a" },
            { "class": "second", "fare": "b" },
            { "class": "first", "fare": "a" },
            { "class": "first", "fare": "c" }
        ]
    */
    unique(array, keyProps) {
        keyProps = [].concat(keyProps);
        const kvArray = (array || []).map(entry => {
            const key = keyProps.map(k => entry[k]).join('|');
            return [key, entry];
        });
        const map = new Map(kvArray);
        return Array.from(map.values());
    },

    simpleUnique(array, propriedade) {
        var ret = new Set();
        array.forEach(r => { if (r[propriedade] != undefined) ret.add(r[propriedade]) });
        return Array.from(ret);
    },

    //varios campos argument
    //groupBy(data, 'campoAgrupamento', 'campoValor')
    //groupBy(data, ['campoAgrupamento1', 'campoAgrupamento2'], 'campoValor')
    // groupBy(array, groups, valueKey) {
    //     var map = new Map;
    //     groups = [].concat(groups);
    //     return (array || []).reduce((r, o) => {
    //         groups.reduce((m, k, i, { length }) => {
    //             var child;
    //             if (m.has(o[k])) return m.get(o[k]);
    //             if (i + 1 === length) {
    //                 child = Object
    //                     .assign(...groups.map(k => ({
    //                         [k]: o[k]
    //                     })), {
    //                         [valueKey]: 0
    //                     });
    //                 r.push(child);
    //             } else {
    //                 child = new Map;
    //             }
    //             m.set(o[k], child);
    //             return child;
    //         }, map)[valueKey] += +o[valueKey];
    //         return r;
    //     }, [])
    // },

    groupBy(array, groups, valueKeys, funcao = 'sum') {
        var map = new Map;
        groups = [].concat(groups);
        valueKeys = [].concat(valueKeys)
        let resultado = (array || []).reduce((r, o) => {
            let g = groups.reduce((m, k, i, { length }) => {
                var child;
                if (m.has(o[k])) return m.get(o[k]);
                if (i + 1 === length) {
                    var valores = { _cont: 0 }
                    valueKeys.forEach(v => valores[v] = 0)
                    child = Object
                        .assign(...groups.map(k => ({
                            [k]: o[k]
                        })), valores);
                    r.push(child);
                } else {
                    child = new Map;
                }
                m.set(o[k], child);
                return child;
            }, map)
            
            switch (funcao) {
                case 'sum':
                case 'avg':
                    valueKeys.forEach(vk => {
                        g[vk] += o[vk]
                    })
                    break;
                case 'max':
                    valueKeys.forEach(vk => {
                        if (o[vk] > g[vk] || g._cont === 0) {
                            g[vk] = o[vk]
                        }
                    })
                    break;     
                case 'min':
                    valueKeys.forEach(vk => {
                        if (o[vk] < g[vk] || g._cont === 0) {
                            g[vk] = o[vk]
                        }
                    })
                    break;
                case 'count':
                    valueKeys.forEach(vk => {
                        g[vk]++
                    })
                    break;                  
            }
            g._cont++
            return r;
        }, [])

        resultado.forEach(r => {
            if (funcao === 'avg') {
                valueKeys.forEach(vk => {
                    r[vk] = r[vk] / r._cont
                })
            }
            delete r._cont
        })

        return resultado
    },

    groupBy2(array, groups, valueKeys, valueFieldsNotChange = []) {
        var map = new Map;
        groups = [].concat(groups);
        valueKeys = [].concat(valueKeys)
        let resultado = (array || []).reduce((r, o) => {
            let g = groups.reduce((m, k, i, { length }) => {
                var child;
                if (m.has(o[k])) return m.get(o[k]);
                if (i + 1 === length) {
                    var valores = { _cont: 0 }
                    valueKeys.forEach(v => valores[v.campo] = 0)
                    child = Object
                        .assign(...groups.map(k => ({
                            [k]: o[k]
                        })),valores);
                    r.push(child);
                } else {
                    child = new Map;
                }
                m.set(o[k], child);
                return child;
            }, map)
            
            valueKeys.forEach(vk => {
                //Verifica se o campo está na lista dos que não podem mudar OU não é string OU não é uma data
                if(valueFieldsNotChange.includes(vk.campo) || typeof o[vk.campo] == 'string' || (o[vk.campo] instanceof Date && !isNaN(o[vk.campo].valueOf()))) {
                    g[vk.campo] = o[vk.campo]
                } else {
                    switch (vk.funcao) {
                        default:
                        case 'sum':
                        case 'avg':
                            g[vk.campo] += o[vk.campo]
                            break;
                        case 'max':
                            if (o[vk.campo] > g[vk.campo] || g._cont === 0) {
                                g[vk.campo] = o[vk.campo]
                            }
                            break;     
                        case 'min':
                            if (o[vk.campo] < g[vk.campo] || g._cont === 0) {
                                g[vk.campo] = o[vk.campo]
                            }                           
                            break;
                        case 'count':                        
                            g[vk.campo]++                            
                            break;   
                    }               
                }
            })
           
            g._cont++
            return r;
        }, [])

        resultado.forEach(r => {
            valueKeys.forEach(vk => {
                if (!(typeof r[vk.campo] == 'string' || (r[vk.campo] instanceof Date && !isNaN(r[vk.campo].valueOf()))) && vk.funcao === 'avg') {
                    r[vk.campo] = r[vk.campo] / r._cont
                }
            })
            delete r._cont
        })

        return resultado
    },

    //acumulador(array, propriedade) {
    //    var retorno = [];
    //    array.forEach((v, i) => {
    //        if (v[propriedade])
    //    })
    //},

    // 1 campo argumento
    /* Exemplos de uso */
    // var ar = [
    //     { a: 'x', o: 1, h: 4, l: 0, c: 3},
    //     { a: 'x', o: 2, h: 6, l: 3, c: 6},
    //     { a: 'y', o: 4, h: 5, l: 2, c: 7}
    // ];
    // console.log('array:', JSON.stringify(ar));
    // console.log('agrupado sum:', groupByFunction(ar, 'a', 'o')); //default
    // console.log('agrupado avg:', groupByFunction(ar, 'a', 'o', 'avg'));
    // console.log('agrupado min:', groupByFunction(ar, 'a', 'o', 'min'));
    // console.log('agrupado max:', groupByFunction(ar, 'a', 'o', 'max'));
    // console.log('agrupado count:', groupByFunction(ar, 'a', 'o', 'count'));
    // console.log('agrupado ohlc:', groupByFunction(ar, 'a', ['o','h','l','c'], 'ohlc'));
    groupByFunction(array, argumentKey, valueKey, aggFunction = 'sum') {
        array = [].concat(array);
        var groupBy = () => {
            return array.reduce(function(groups, item) {
                const val = item[argumentKey]
                groups[val] = groups[val] || []
                groups[val].push(item)
                return groups
            }, {})
        }

        var grouppedValues = groupBy();

        //console.log('grouppedValues:', grouppedValues)

        var keys = Object.keys(grouppedValues);
        var ret = [];

        for (let k of keys) {
            switch (aggFunction) {
                case 'count':
                    ret.push({
                        [argumentKey]: k,
                        [valueKey]: this.count(grouppedValues[k])
                    });
                    break;
                case 'ohlc':
                    if (valueKey.constructor.name != 'Array' || valueKey.length != 4) {
                        alert('Funcao do tipo "ohlc" necessita de 4 campos (na ordem "o", "h", "l", "c") no parametro "valueKey"')
                        return null;
                    }
                    ret.push({
                        [argumentKey]: k,
                        [valueKey[0]]: this.first(grouppedValues[k])[valueKey[0]], //o
                        [valueKey[1]]: this.max(grouppedValues[k], valueKey[1]),   //h
                        [valueKey[2]]: this.min(grouppedValues[k], valueKey[2]),   //l
                        [valueKey[3]]: this.last(grouppedValues[k])[valueKey[3]],  //c
                    });
                    break;
                case 'range':
                    if (valueKey.constructor.name != 'Array' || valueKey.length != 2) {
                        alert('Funcao do tipo "range" necessita de 2 campos (na ordem low e high) no parametro "valueKey"')
                        return null;
                    }
                    ret.push({
                        [argumentKey]: k,
                        [valueKey[0]]: this.min(grouppedValues[k], valueKey[0]), //max
                        [valueKey[1]]: this.max(grouppedValues[k], valueKey[1]), //min
                    });
                    break;
                case 'acc': //acumulador
                    var acc = 0;
                    if (ret.length)
                        acc = ret[ret.length-1][valueKey];
                    ret.push({
                        [argumentKey]: k,
                        [valueKey]: acc+this.sum(grouppedValues[k], valueKey)
                    });
                    break;
                case 'diffPrevious': //diferença do anterior
                    var previous = 0;
                    if (ret.length) {
                        previous = ret[ret.length-1]['______vis_temp'] || 0;
                        delete ret[ret.length-1]['______vis_temp'];
                    }
                    var sum = this.sum(grouppedValues[k], valueKey);
                    ret.push({
                        [argumentKey]: k,
                        [valueKey]: !ret.length ? undefined : sum - previous,
                        ['______vis_temp']: sum
                    });
                    break;
                case 'diffPrevious%': //diferença do anterior - percentual
                    var previous = 0;
                    if (ret.length) {
                        previous = ret[ret.length-1]['______vis_temp'] || 0;
                        delete ret[ret.length-1]['______vis_temp'];
                    }
                    var sum = this.sum(grouppedValues[k], valueKey);
                    ret.push({
                        [argumentKey]: k,
                        [valueKey]: !ret.length ? undefined : previous == 0 ? 0 : sum * 100 / previous,
                        ['______vis_temp']: sum
                    });
                    break;
                case 'percTotal': //percentual do total: etapa 1: faz o sum
                    ret.push({
                        [argumentKey]: k,
                        [valueKey]: this.sum(grouppedValues[k], valueKey)
                    });
                    break;
                default:
                    ret.push({
                        [argumentKey]: k,
                        [valueKey]: this[aggFunction](grouppedValues[k], valueKey)
                    });
                    break;
            }
        }

        //pós-procesamento
        switch (aggFunction) {
            case 'diffPrevious': //limpeza
            case 'diffPrevious%': //limpeza
                delete ret[ret.length-1]['______vis_temp'];
                break;
            case 'percTotal': //percentual do total: etapa 2: faz o calculo
                var total = ret.map(i => i[valueKey]).reduce((acc, cur) => acc + cur);
                ret.forEach(i => {
                    i[valueKey] = i[valueKey] == 0 ? 0 : i[valueKey] * 100 / total;
                })
                break;
            default:
                break;
        }

        return ret;
    },

    sortAsc(array, propriedade) {
        function asc(a, b) {
            if (a[propriedade] < b[propriedade]) return -1;
            if (a[propriedade] > b[propriedade]) return 1;
            return 0;
        }
        return [...array].sort(asc);
    },

    sortDesc(array, propriedade) {
        function desc(a, b) {
            if (a[propriedade] > b[propriedade]) return -1;
            if (a[propriedade] < b[propriedade]) return 1;
            return 0;
        }
        return [...array].sort(desc);
    },

    top(array, total, propriedadeSort, tipo = 'contagem') { //contagem|valor inicial

        if (!Number(total)) {
            alert('Funcao Top() sem \'total\' a retornar');
            return array;
        }

        let temp = null;
        if (propriedadeSort) {
            temp = this.sortDesc(array, propriedadeSort);
            if (tipo != 'contagem') {
                let temp2 = [];
                let idx = temp.findIndex(i => i[propriedadeSort] >= total);
                while(idx >= 0) {
                    temp2 = temp2.concat(temp.splice(idx, 1));
                    idx = temp.findIndex(i => i[propriedadeSort] >= total);
                }
                return temp2;
            }
        }

        return (temp || array).slice(0, total);
    },

    //resto do array somado
    remaining(array, ignoreTop, propriedade) {
        let arrayTemp = this.sortDesc(array, propriedade);
        arrayTemp.splice(0, ignoreTop);

        let ret = {};
        ret[propriedade] = this.sum(arrayTemp, propriedade);
        return ret;
    },

    except(arrayFull, arrayExcept, argumentProp) {
        if (!argumentProp) {
            alert('Funcao Except() sem \'argumentProp\'');
            return array;
        }

        (arrayExcept || []).forEach(i => {
            let idx = arrayFull.findIndex(f => f[argumentProp] == i[argumentProp]);
            if (idx >=0)
                arrayFull.splice(idx,1);
        })
        return arrayFull;
    }

}